import { getRemainingTimeFormated } from '@dtvgo/date-utils';
import { jsx } from 'react/jsx-runtime';

/* External */

function RemainingTime(_ref) {
  var progress = _ref.progress,
    duration = _ref.duration,
    className = _ref.className;
  return /*#__PURE__*/jsx("div", {
    className: "dtv-common-c-remaining-time ".concat(className),
    children: getRemainingTimeFormated(progress, duration)
  });
}
RemainingTime.defaultProps = {
  progress: 0,
  duration: 0,
  className: ''
};

export { RemainingTime as default };
//# sourceMappingURL=RemainingTime.js.map
